module.exports = __webpack_public_path__ + "img/bar2Green.c866d2b3.svg";